var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('AlbumListContainer'),_c('loader',{attrs:{"loading-promise":_vm.albumsPromise}},[_c('div',{staticClass:"gimme-some-space"},[_c('albums-wall',{attrs:{"albums":_vm.albums,"pages":_vm.pages}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }